import firebase from '../../../config/firebase';

const database = firebase.database();

/**
 * get all Sportsletters - that is, newsletters for sports
 */
export function getSportsletters(callback) {

    database.ref('sports').once('value')
        .then((snapshot) => {
            const sports = snapshot.val();
            callback(true, sports, null);
        });
}

/**
 * Create new sportsletters
 */
export function createNewSports (data, callback) {
    var newId = database.ref().child('sports').push().key;
    data["id"] = newId;

    database.ref('sports/' + newId).set(data, function(error) {
        if (error) {
            callback(false, null, error);
        } else {
            callback(true, data, null);
        }
    })
}

/**
 * Edit sports
 */
export function editSports (id, data, callback) {

    database.ref('sports/' + id).set(data, function(error) {
        if (error) {
            callback(false, null, error);
        } else {
            callback(true, data, null);
        }
    });
}

/**
 * Delete sports
 */
export function deleteSports(id, callback) {
    database.ref('sports').child(id).remove(function(error) {
        if (error) {
            callback(false, null, error);
        } else {
            callback(true, id, null);
        }
    });
}
